import React,{useMemo} from 'react'
import style from './style.module.scss';
const Pagination = (props) => {
    const {data} = props;
    
    const renderPagination = useMemo(() => {
        if(!data) return null
        if(!!!data?.blockBegin) return null;
        
        const begin = parseInt(data.blockBegin ?? 0);
        const end = parseInt(data.blockEnd ?? 0);
        const current = parseInt(data.curPage ?? 0);
        let renderData = [];

        const prev = parseInt(data.prevBlock ?? 0);
        const next = parseInt(data.nextBlock ?? 0);

        // if(parseInt(data.totPage) < 2) return null

        if(prev > 1) {
            renderData.push(<li key={new Date().getTime()+"pagination_prevAll"}
                onClick={() => props.onClick(1)}
            >
            {"<<"}
        </li>)
        }
        if(prev > 0) {
            renderData.push(<li key={new Date().getTime()+"pagination_prev"}
                onClick={() => props.onClick(data.prevPage)}
            >
                {"<"}
            </li>)
        }
        
        for(let i=begin; i<=end; i++) {
            renderData.push(<li
                key={new Date().getTime()+"pagination"+i}
                className={i === current ? style.on : ""}
                onClick={() => props.onClick(i)}
                >
                    {i}
                </li>);
        }
        if(next > 0) {
            renderData.push(<li key={new Date().getTime()+"pagination_next"}
                onClick={() => props.onClick(data.nextPage)}
            >
                {">"}
            </li>)
            if(next > 1) {
                renderData.push(<li key={new Date().getTime()+"pagination_nextAll"}
                    onClick={() => props.onClick(data.totPage)}
                >
                {">>"}
            </li>)
            }
        }
        return renderData
    },[props,data])
    
    return <ul style={props.style} className={`${style.paginationBox}`}>
            {renderPagination}
        </ul>
}

export default Pagination;